export default "__VITE_ASSET__CkG4wMJP__"